import 'lightslider';
import 'lightgallery';
import 'lg-zoom';
import 'lg-thumbnail';
import 'lg-video';
import jQuery from 'jquery';

((root, $, imageGallerySelector) => {
  const $imageGallery = $(imageGallerySelector);

  $imageGallery.lightSlider({
    gallery: true,
    item: 1,
    auto: true,
    pause: 3000,
    loop: true,
    thumbItem: $imageGallery.data('amount'),
    slideMargin: 0,
    enableDrag: false,
    currentPagerPosition: 'left',
    plugins: ['lg-video'],
    videojs: true,
    autoplay: true,
    videojsOptions: {
      muted: true,
      autoplay: true,
      playsinline: true,
    },
    onSliderLoad(el) {
      el.lightGallery({
        zoom: true,
        selector: `${imageGallerySelector} .lslide`,
      });
    },
  });
})(window, jQuery, '#imageGallery');
